<template>
  <div class="announcements-show-container">
    <section class="announcements-heading">
      <div class="announcements-heading__container">
        <div v-if="hasThumbnail" class="announcements-heading__thumbnail">
          <ImgLazy
            :image-url="thumbnailImageUrl"
            alt-text="サムネイル画像"
            aspect-ratio="40 / 21"
          />
        </div>
        <h1 class="announcements-heading__title">
          <div class="announcements-heading__creation-time">
            {{ formattedStartedAt }}
          </div>
          <div class="announcements-heading__headline">
            {{ title }}
          </div>
        </h1>
      </div>
    </section>
    <section class="announcements-main">
      <div class="announcements-main__container">
        <KittyHtmlSanitized
          additional-class="announcements-main__textarea"
          :html="contentHtml"
        />
      </div>
    </section>
    <div v-if="!isApp">
      <section class="back-to-announcements">
        <div class="back-to-announcements__container">
          <a
            v-if="isBackSpecialIndexPage"
            :href="specialsAnnouncementsPath"
            class="back-to-announcements__link tl-link-chevron-back--left"
          >
            特集・キャンペーン一覧へ戻る
          </a>
          <a
            v-else-if="isBackTopPage"
            :href="rootPath"
            class="back-to-announcements__link tl-link-chevron-back--left"
          >
            gifteeトップへ戻る
          </a>
          <a
            v-else-if="isBackColumnIndexPage"
            :href="gifteeColumnsAnnouncementsPath"
            class="back-to-announcements__link tl-link-chevron-back--left"
          >
            ギフトコラム一覧へ戻る
          </a>
          <span
            v-else
            class="back-to-announcements__link tl-link-chevron-back--left"
            @click="onClickBackToAnnouncementsLink"
          >
            戻る
          </span>
        </div>
      </section>
      <section class="announcements__back-to-top">
        <span class="back-to-top-link subhead" @click="onClickBackToTopLink">
          ページトップへ ▲
        </span>
      </section>
    </div>
  </div>
</template>
<script>
import ImgLazy from '../../atoms/images/ImgLazy.vue'
import KittyHtmlSanitized from '../../atoms/html/KittyHtmlSanitized.vue'
import { draggableConstants } from '../../../constants/draggableConstants'

const LONG_PRESS_SEC = draggableConstants.LONG_PRESS_SEC

export default {
  components: { ImgLazy, KittyHtmlSanitized },
  props: {
    hasThumbnail: {
      type: Boolean,
      required: false,
      default: false
    },
    thumbnailImageUrl: {
      type: String,
      required: false,
      default: ''
    },
    formattedStartedAt: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    contentHtml: {
      type: String,
      required: false,
      default: ''
    },
    isApp: {
      type: Boolean,
      required: false,
      default: false
    },
    announcementTypeName: {
      type: String,
      required: false,
      default: ''
    },
    specialsAnnouncementsPath: {
      type: String,
      required: false,
      default: ''
    },
    rootPath: {
      type: String,
      required: false,
      default: ''
    },
    gifteeColumnsAnnouncementsPath: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      pressTimer: null
    }
  },
  computed: {
    isBackSpecialIndexPage() {
      return this.announcementTypeName === 'special'
    },
    isBackTopPage() {
      return this.announcementTypeName === 'notice'
    },
    isBackColumnIndexPage() {
      return this.announcementTypeName === 'giftee_column'
    }
  },
  mounted() {
    this.bindRightClickEvent()
  },
  updated() {
    // htmlContentが更新された時にも再バインドが必要
    this.bindRightClickEvent()
  },
  methods: {
    onClickBackToTopLink() {
      window.scrollTo({ top, behavior: 'smooth' })
      event.preventDefault()
    },
    onClickBackToAnnouncementsLink() {
      window.history.back()
    },
    pushDataLayer(event) {
      if (this.isApp) {
        // eslint-disable-next-line no-undef
        logEvent('view_contextmenu', {
          image_url: event.target.src
        })
        return
      }
      dataLayer.push({
        event: 'view_contextmenu',
        image_url: event.target.src
      })
    },
    onClickRight(event) {
      this.pushDataLayer(event)
    },
    startPress(event) {
      this.pressTimer = setTimeout(() => {
        this.pushDataLayer(event)
      }, LONG_PRESS_SEC)
    },
    endPress() {
      if (!this.pressTimer) return

      clearTimeout(this.pressTimer)
      this.pressTimer = null
    },
    bindRightClickEvent() {
      const container = this.$el.querySelector('.announcements-main__textarea')
      if (!container) return

      const images = container.querySelectorAll('.contextmenu-target-image')
      images.forEach(img => {
        // 二重バインドを避けるために一度削除してから追加
        // PC用のイベント
        img.removeEventListener('contextmenu', this.onClickRight)
        img.addEventListener('contextmenu', this.onClickRight)
        // SP用のイベント
        img.removeEventListener('touchstart', this.startPress)
        img.removeEventListener('touchend', this.endPress)
        img.removeEventListener('touchcancel', this.endPress)
        img.addEventListener('touchstart', this.startPress)
        img.addEventListener('touchend', this.endPress)
        img.addEventListener('touchcancel', this.endPress)
      })
    }
  }
}
</script>
